/**
 * Small wrapper so the engagement hook can be mounted alongside other
 * router-level components (needs to live inside <BrowserRouter>).
 */
import useEngagementTracking from "@/hooks/useEngagementTracking";

export default function EngagementTracker() {
  useEngagementTracking();
  return null;
}
